
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/taxdebtoffers",
      function () {
        return require("private-next-pages/taxdebtoffers/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/taxdebtoffers"])
      });
    }
  